__webpack_require__.p = "/wp-content/plugins/qburst-entrata/old-ui/build/";